import $ from 'jquery';
import 'slick-carousel';
import Modal from './modal';
import getLayout from './get-modal-layout';

const classNames = {
  MOBILE_PHONE_HIDDEN: `mobile-phone--hidden`
};

class ModalInfrastructure extends Modal {
  constructor() {
    super();
    this.controls = [...this.page.querySelectorAll(`.infrastructure__pictures .js-pictures-toggle`)];
    this.phone = this.page.querySelector(`.mobile-phone`);
    this.slider = null;
  }

  init(locale) {
    this.locale = locale;
    super.createModal();
    this.createWrap();
    this.bindHandlers();
  }

  createWrap() {
    super.addLayout(getLayout(`infrastructure-wrap`));
  }

  createSlider = (type) => {
    const container = this.page.querySelector(`#infrastructure-slider`);
    const sliderLayout = getLayout(`infrastructure-${type}`, null, this.locale);

    container.innerHTML = ``;
    container.innerHTML = sliderLayout;

    this.slider = container.querySelector(`#modal-infrastructure-${type}`);
    this.initSlider();
  };

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
    this.phone.classList.toggle(classNames.MOBILE_PHONE_HIDDEN, isModalShown);
  };

  initSlider() {
    $(this.slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
    });
  };

  bindHandlers() {
    this.controls.forEach((control) => {
      control.addEventListener(`click`, ({target}) => {
        this.createSlider(target.dataset.id);
        $(this.slider).slick(`slickGoTo`, 0, true);
        this.toggleModal(true);
      });
    });
  }
}

const modalInfrastructure = new ModalInfrastructure();

export default modalInfrastructure;
